import { render, staticRenderFns } from "./taskList.vue?vue&type=template&id=d3a06dcc&"
import script from "./taskList.vue?vue&type=script&lang=js&"
export * from "./taskList.vue?vue&type=script&lang=js&"
import style0 from "./taskList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports